import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@repo/design-system/components/ui/checkbox';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectAuthState } from '@repo/store/maps/slices/auth';
import { selectFoundPins } from '@repo/store/maps/slices/mapData';
import type { MapDataLocationFeature } from '@repo/types/maps/map-types';
import React, { useMemo } from 'react';
import { useMapPinOperations } from '../game-map/hooks/useMapPinOperations';
export const LocationHoverTooltip = t0 => {
  const $ = _c(25);
  const {
    marker
  } = t0;
  const foundPins = useAppSelector(selectFoundPins);
  const authState = useAppSelector(selectAuthState);
  const [mediaError, setMediaError] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const locationSubcategories = useAppSelector(_temp);
  const {
    togglePinFound,
    isTogglingPin
  } = useMapPinOperations();
  const subcategory = locationSubcategories[marker?.properties?.externalId] || null;
  let t1;
  if ($[0] !== marker?.properties?.externalId || $[1] !== togglePinFound) {
    t1 = () => {
      togglePinFound(marker?.properties?.externalId, "hover-tooltip");
    };
    $[0] = marker?.properties?.externalId;
    $[1] = togglePinFound;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleToggleFound = t1;
  const isFound = foundPins[marker?.properties?.externalId] || false;
  const displayTitle = marker?.properties?.title || subcategory?.title;
  const imageId = marker?.properties?.imageId;
  const imageSrc = `${process.env.NEXT_PUBLIC_CDN_URL}/game_map_pin/${imageId}/50.webp`;
  let t2;
  let t3;
  if ($[3] !== imageId || $[4] !== imageSrc) {
    t2 = () => {
      if (!imageId) {
        return;
      }
      const testImage = new Image();
      testImage.onload = () => {
        setLoaded(true);
      };
      testImage.onerror = () => {
        setMediaError(true);
      };
      testImage.src = imageSrc;
    };
    t3 = [imageId, imageSrc];
    $[3] = imageId;
    $[4] = imageSrc;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      backgroundColor: "wemod.elevated.100",
      color: "text.primary",
      borderRadius: "12",
      padding: "[8px 16px]",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "8"
    });
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== imageId || $[9] !== imageSrc || $[10] !== loaded || $[11] !== mediaError) {
    t5 = imageId && <div className={css({
      width: "[24px]",
      height: "[24px]",
      borderRadius: "4"
    })}>{loaded && !mediaError && <img loading="lazy" src={imageSrc} className={css({
        borderRadius: "4"
      })} alt="Location media" />}</div>;
    $[8] = imageId;
    $[9] = imageSrc;
    $[10] = loaded;
    $[11] = mediaError;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = css({
      userSelect: "none"
    });
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== displayTitle) {
    t7 = <p className={t6}>{displayTitle}</p>;
    $[14] = displayTitle;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== authState.isAuthenticated || $[17] !== handleToggleFound || $[18] !== isFound || $[19] !== isTogglingPin) {
    t8 = authState.isAuthenticated && <Checkbox id="found-pin" checked={isFound} onChange={handleToggleFound} disabled={isTogglingPin} size="sm" />;
    $[16] = authState.isAuthenticated;
    $[17] = handleToggleFound;
    $[18] = isFound;
    $[19] = isTogglingPin;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className={t4}>{t5}{t7}{t8}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
function _temp(state) {
  return state.mapData.locationSubcategories;
}